import { getRequest } from "@/utils/http";

/**
 *
 * @param {*} params
 * @returns  栏目列表
 */
export function getSpecialSourceColumnHandle(params = {}) {
  return getRequest("/zplan/api/menu", params);
}

/**
 * 根据栏目查询专题
 * @param {*} params  栏目的id
 * @returns  专题列表
 */
export function getSpecialTypeDirectoryHandle(params) {
  return getRequest("/zplan/api/topic", params);
}

/**
 *
 * @param {*} params 专题名称  分页参数
 * @returns  文章列表
 */
export function getTypeSourceArticleHandle(params) {
  return getRequest("/zplan/api/article", params);
}
